module.exports = __webpack_public_path__ + "img/image8@2x.dd7a04f3.png";